define('setup/admin-audio/admin-audio',['require','api-access','api-access','api-access','../setup-configurator','i18next','knockout','settings/lib/country-selector/country-selector','lodash','mixpanel-helper'],function (require) {
    var userApi = require('api-access').user;
    var adminApi = require('api-access').extadmin;
    var meetingsApi = require('api-access').meetings;

    var setupConfigurator = require('../setup-configurator');
    var i18n = require('i18next');
    var ko = require('knockout');
    var CountrySelector = require('settings/lib/country-selector/country-selector');
    var _ = require('lodash');
    var mixpanelHelper = require('mixpanel-helper');

    return function () {
        var self = this;

        // isTollFreeActive controls the checkbox state
        self.isTollFreeActive = ko.observable(false);

        // isTollFreeEnabled controls the visibility of the
        // list of countries... since we have to make an API call
        // when the checkbox is toggle, we don't want a flash
        self.isTollFreeEnabled = ko.observable(false);
        self.countrySelector = ko.observable();
        self.locale = ko.observable();

        self.isModalOpen = ko.observable(false);
        self.accountKey = ko.observable();

        self.selectedTollFreeCountries = ko.observableArray();

        self.allowedTollFreeCountries = ko.observable();
        self.preferredTollFreeCountry = ko.observable();
        self.isCountrySelectorVisible = ko.observable(false);
        self.allTollFreeCountries = ko.observable();
        self.backEnabled = ko.observable();
        self.tierName = ko.observable();

        // this stores the configuration for the page
        // and gets populated on activation
        var setupConfig;

        self.checkboxHint = ko.computed(function () {
            return self.isTollFreeActive() ? i18n.t('setup.admin-toll-free.on') : i18n.t('setup.admin-toll-free.off');
        });

        self.rateString = function () {
            return i18n.t('setup.admin-toll-free.usCanadaRate', '<strong>', '</strong>');
        };

        self.formatCountries = function (codesResponse) {
            var codes = codesResponse || [];
            return codes.map(function (code) {
                return {
                    code: code,
                    displayCountry: i18n.t('countries.' + code)
                };
            });
        };

        self.formatCountriesString = function (countries) {
            return _.pluck(countries, 'displayCountry').join(', ');
        };

        self.formattedAllowedTollFreeCountries = ko.computed(function () {
            return self.formatCountriesString(self.formatCountries(self.allowedTollFreeCountries()));
        });

        self.onTFChange = function (ctx, event) {
            var enabled = event.target.checked;
            var data = {tollFreeEnabled: enabled, tollFreeAccessible: enabled};

            var getCountries = function () {
                if (enabled) {
                    return adminApi
                        .getDefaultTemplate(self.accountKey())
                        .then(function (productSettings) {
                            self.allowedTollFreeCountries(productSettings.allowedTollFreeCountries);
                            self.preferredTollFreeCountry(productSettings.preferredTollFreeCountry);
                            self.isTollFreeEnabled(true);
                            mixpanelHelper.track('Activated Tollfree');
                        });
                }
                self.isTollFreeEnabled(false);
                return undefined;
            };

            adminApi
                .updateProductSettings(self.accountKey(), self.tierName(), data)
                .then(getCountries);
        };

        self.showCountrySelector = function () {
            var options = {
                titleKeyPrefix: '',
                onSave: function onSave(selected, prefered) {
                    var data = {
                        allowedTollFreeCountries: selected,
                        preferredTollFreeCountry: prefered || null
                    };

                    return adminApi
                        .updateProductSettings(self.accountKey(), self.tierName(), data)
                        .then(function () {
                            self.allowedTollFreeCountries(selected);
                            self.preferredTollFreeCountry(prefered);
                        });
                },

                loadAudioSettings: function loadProductSettings() {
                    var settings = {
                        locale: self.locale(),
                        audio: {
                            allowedTollFreeCountries: self.allTollFreeCountries(),
                            defaultTollFreeCountries: self.allowedTollFreeCountries(),
                            preferredTollFreeCountry: self.preferredTollFreeCountry()
                        }
                    };

                    return $.Deferred().resolve(settings, null);
                }
            };

            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                var title = i18n.t('setup.admin-toll-free.countrySelectorTitle');

                new CountrySelector(title, true, options)
                    .show()
                    .then(function () {
                        self.isModalOpen(false);
                    })
                    .fail(function () {
                        self.isModalOpen(false);
                    });
            }
        };

        self.back = function () {
            mixpanelHelper.trackLink(setupConfig['admin-audio'].backUrl, 'Admin audio page: Clicked Back');
        };

        self.done = function () {
            window.location.href = setupConfig['admin-audio'].nextUrl;
        };

        self.activate = function () {
            var fetchPageData = $.when(
                    userApi.me(),
                    userApi.settings()
                )
                .then(function (meResponse, settingsResponse) {
                    var me = meResponse[0];
                    var settings = settingsResponse[0];

                    self.tierName(settings.tierName);
                    self.accountKey(me.accountKey);
                    self.locale(me.locale);

                    var loadCountriesAndSettings = $.when(
                        adminApi.getAllowedTFCountries(self.accountKey(), self.tierName()),
                        adminApi.getDefaultTemplate(self.accountKey())
                    );

                    return loadCountriesAndSettings
                        .then(function (respCountries, productSettings) {
                            self.allTollFreeCountries(respCountries[0]);
                            self.isTollFreeEnabled(productSettings.tollFreeEnabled);
                            self.isTollFreeActive(productSettings.tollFreeEnabled);
                            self.allowedTollFreeCountries(productSettings.allowedTollFreeCountries);
                            self.preferredTollFreeCountry(productSettings.preferredTollFreeCountry);
                        });
                });

            return $.when(
                setupConfigurator.update(),
                fetchPageData
            ).then(function () {
                setupConfig = setupConfigurator.getSetupData();

                self.backEnabled(!!setupConfig['admin-audio'].backUrl);

                // set the flag at the account level so we can prevent
                // other admins to see this page
                meetingsApi.updateAccountSettings(self.accountKey(), {adminAudioOnboardingViewed: true});
            });
        };

        self.compositionComplete = function () {
            mixpanelHelper.track('Loaded Admin audio page');
        };
    };
});

